import { Helmet } from "react-helmet";
import city from '../../assets/images/solutions_city.webp'
import stadium from '../../assets/images/solutions_stadiums.webp'
import rzhd from '../../assets/images/solutions_rzhd.webp'
import './solutions.scss';
import AirPhotos from '../ProjectsPage/airports';
import data from '../ProjectsPage/data';
import { useTranslation } from "react-i18next";

const Solutions: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="solutions">
            <Helmet>
                <title>Решения по безопасности | Видеонаблюдение и контроль доступа</title>
                <meta name="description" content="Решения по обеспечению безопасности для городов, аэропортов, аэродромов, вокзалов и стадионов. Видеонаблюдение, контроль доступа, обнаружение взрывчатых устройств и другие системы безопасности." />
                <meta name="keywords" content="Безопасный город, Аэропорт безопасность, Аэродром безопасность, Видеонаблюдение для вокзала, Безопасность стадионов, СОТ, СКУД, системы обнаружения взрывчатых устройств, контроль доступа" />
            </Helmet>
            <div className="solution">
                <div className="solution__text ">
                    <h2 className="solution__header">{t("solutions.stadiums.title")}</h2>
                    <p className="solution__p">{t("solutions.stadiums.description")} <br />{t("solutions.stadiums.systems.system1")}<br /> {t("solutions.stadiums.systems.system2")}</p>
                </div>
                <img src={stadium} alt="Stadiums" className="solution__img" />
            </div>
            <div className="solution">
                <div className="solution__text ">
                    <h2 className="solution__header">{t("solutions.safe_city.title")}</h2>
                    <p className="solution__p">{t("solutions.safe_city.description")}</p>
                </div>
                <img src={city} alt="safe city" className="solution__img" />
            </div>
            <div className="solution">
                <div className="solution__text ">
                    <h2 className="solution__header">{t("solutions.airports.title")}</h2>
                    <p className="solution__p">{t("solutions.airports.points.point1")}</p>
                    <p className="solution__p">{t("solutions.airports.points.point2")}</p>
                    <p className="solution__p">{t("solutions.airports.points.point3")}</p>
                </div>

                <AirPhotos images={data} />
            </div>
            <div className="solution">
                <div className="solution__text ">
                    <h2 className="solution__header">{t("solutions.railway_stations.title")}</h2>
                    <p className="solution__p">{t("solutions.railway_stations.description")}<br />{t("solutions.railway_stations.components.component1")}<br />{t("solutions.railway_stations.components.component2")}</p>
                </div>
                <img src={rzhd} alt="Train stations" className="solution__img" />
            </div>
        </section>
    )
}

export default Solutions;